import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listItems = ({pagination, userIds, snapshotDateTime, folderId, searchTerm}) => {
  return POST('exchange/calendar/search', {pagination, userIds, snapshotDateTime, folderId, searchTerm: trimString(searchTerm)});
}

const listCalendarBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('exchange/calendar/breadcrumbs', {userId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, extension, code, storageDestinationId, dataType, storageDestinationType}) => {
  return POST('exchange/calendar/export', {snapshotDateTime, sourceIds, searchTerm: trimString(searchTerm), selectedIds, extension, storageDestinationId, dataType, storageDestinationType}, {code: code ? code : null})
}

const restoreSnapshot = ({snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, RestoreType, code}) => {
  return POST('exchange/calendar/restore', {snapshotDateTime, sourceIds, searchTerm: trimString(searchTerm), destinationId, snapshotId, selectedIds, RestoreType}, {code: code ? code : null})
}

export {
  listItems,
  listCalendarBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
